module.exports = __webpack_public_path__ + "img/余额.5029a9c6.svg";